import { render, staticRenderFns } from "./migas.vue?vue&type=template&id=469292fb&scoped=true&lang=pug"
import script from "./migas.vue?vue&type=script&lang=js"
export * from "./migas.vue?vue&type=script&lang=js"
import style0 from "./migas.vue?vue&type=style&index=0&id=469292fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469292fb",
  null
  
)

export default component.exports